module.exports = __webpack_public_path__ + "img/sidebar-dec.290c440.webp";